import { c as _c } from "react/compiler-runtime";
import { ReactNode } from 'react';
import MailingStatsSkeleton from 'modules/campaigns/campaign-steps/components/mailing-stats-skeleton';
interface Props<T> {
  data?: T;
  children: (data: NonNullable<T>) => ReactNode;
}

/**
 * Wrapper for mailing stats rendering states.
 * - `undefined` is treated as a loading state and renders the skeleton.
 * - `null` is treated as no data and renders nothing.
 * - Any other value is rendered via `children`.
 */
export const MailingStatsWrapper = t0 => {
  const $ = _c(3);
  const {
    children,
    data
  } = t0;
  let t1;
  if ($[0] !== children || $[1] !== data) {
    t1 = data === undefined ? <MailingStatsSkeleton /> : data === null ? null : children(data);
    $[0] = children;
    $[1] = data;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};